import { AspectRatioStory, StoryConfig, TextPreset } from 'services/story.service';
import { useAppSelector, useAppDispatch } from 'store/store-hooks';
import { handleStoryConfig } from 'components/app/editor/_mediator/editor.slice';

const KEYS = {
  titlePreset: 'titleTextPreset',
  creditsPreset: 'creditsTextPreset',
  credits: 'creditsText',
  title: 'titleText',
} as const satisfies Record<string, keyof StoryConfig>;

export const useEditorTitleCredits = () => {
  const config = useAppSelector((state) => state.editor.storyConfig);
  const dispatch = useAppDispatch();

  return (preset: TextPreset, text: string, aspectRatio: AspectRatioStory, isTitle: boolean, sync: boolean) => {
    if (!config) return;
    const presetKey = isTitle ? KEYS.titlePreset : KEYS.creditsPreset;
    const textKey = isTitle ? KEYS.title : KEYS.credits;
    const payload = sync ? { [KEYS.titlePreset]: preset, [KEYS.creditsPreset]: preset } : { [presetKey]: preset };
    const aspectRatioChanged = config.aspectRatio !== aspectRatio;
    dispatch(
      handleStoryConfig({
        data: {
          titleCreditsAction: aspectRatioChanged || sync ? 'both' : isTitle ? 'title' : 'credits',
          storyConfig: {
            ...config,
            ...payload,
            aspectRatio,
            [textKey]: text,
          },
        },
        backupParams: { title: 'Story Title/Credits' },
      })
    );
  };
};
